import {
  FluentProvider,
  PartialTheme,
  Popover,
  PopoverProps,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";
import { ETheme } from "@/DependenciesV9";


interface PopoverCustomProps {
  rcName?: string;
  theme?: ETheme;
}

const PopoverCustom = (props: PopoverCustomProps & PopoverProps) => {
  const renderTheme: PartialTheme = props.theme === "dark" ? webDarkTheme : webLightTheme;
  return (
    <FluentProvider theme={renderTheme}>
      <Popover closeOnScroll {...props} />
    </FluentProvider>
  );
};

export default PopoverCustom;
